import { ProductDetailThemeModeConfig } from './types';

const light: ProductDetailThemeModeConfig = {
  productDetail: {
    backgroundColor: '#ffffff', // Light background color
    backgroundGradient: 'linear-gradient(to bottom, #33adff11, #ffffff)', // Gradient for background
    cardBackgroundGradient: 'linear-gradient(to bottom, #33adff55, #0000FF22)', // Gradient for background
    hoverBackgroundGradient: 'linear-gradient(to bottom, #33adff99, #0000FF22)', // Gradient for hover background
    borderColor: ' #0775bc ', // Border color for light theme
    boxShadow: '0 8px 12px 0 #80ccff, 0 8px 12px #33adff, 8px 10px 12px 0 #33adff', // Box shadow for hover
    textColor: '#444444',
    labelBGColor: '#50521120',
    normalButtonBGColor: '#0775bc',
    normalButtonBorderColor: '2px solid #267DAC',
  },
};

export default light;
